import { mapboxToken } from "./configuration";
import type { Bounds } from "./model";

export const geocode = async (value: string) =>
  (await parseLocation(value)) ?? (await search(value));

const search = async (value: string) => {
  const response = await fetch(
    `https://api.mapbox.com/geocoding/v5/mapbox.places/${value}.json?access_token=${mapboxToken}&types=country,region,district,place,postcode,address`,
  );
  const results = (await response.json()) as GeoJSON.FeatureCollection;
  const [feature] = results.features;
  if (!feature) return;
  const { bbox } = feature;
  if (bbox) {
    const [minLongitude, minLatitude, maxLongitude, maxLatitude] = bbox;
    return [
      minLongitude,
      minLatitude,
      maxLongitude,
      maxLatitude,
    ] satisfies Bounds;
  }
  return (feature as unknown as { center: [number, number] } | undefined)
    ?.center;
};

export const parseLocation = async (value: string) =>
  (await parseMgrs(value)) ?? (await parseCoordinate(value));

const parseMgrs = async (value: string) => {
  const mgrs = await import("mgrs");
  try {
    return mgrs.inverse(value.replace(/\s/g, ""));
  } catch {
    // Ignore
  }
};

const parseCoordinate = async (value: string) => {
  const { Parser } = await import("@openaip/coordinate-parser");
  const parser = new Parser();
  try {
    const { latitude, longitude } = parser.parse(value);
    return [longitude, latitude] satisfies Bounds;
  } catch {
    return undefined;
  }
};
